import React, { useEffect, useRef } from 'react';
import { TweenMax, Expo } from 'gsap';

const MathUtils = {
  lineEq: (y2, y1, x2, x1, currentVal) => {
    const m = (y2 - y1) / (x2 - x1);
    const b = y1 - m * x1;
    return m * currentVal + b;
  },
  lerp: (a, b, n) => (1 - n) * a + n * b,
  getRandomFloat: (min, max) => (Math.random() * (max - min) + min).toFixed(2),
};

const getMousePos = (e) => {
  let posx = 0;
  let posy = 0;
  if (!e) e = window.event;
  if (e.pageX || e.pageY) {
    posx = e.pageX;
    posy = e.pageY;
  } else if (e.clientX || e.clientY) {
    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }
  return { x: posx, y: posy };
};

const CustomCursor = () => {
  const cursorRef = useRef(null);
  const circleRef = useRef(null);
  const arrowLeftRef = useRef(null);
  const arrowRightRef = useRef(null);

  let winsize = { width: window.innerWidth, height: window.innerHeight };
  let mousepos = { x: winsize.width / 2, y: winsize.height / 2 };
  const lastMousePos = { x: 0, y: 0 };
  let scale = 1;
  let lastScale = 1;

  useEffect(() => {
    const calcWinsize = () => {
      winsize = { width: window.innerWidth, height: window.innerHeight };
    };

    const mouseMoveHandler = (ev) => {
      mousepos = getMousePos(ev);
    };

    window.addEventListener('resize', calcWinsize);
    window.addEventListener('mousemove', mouseMoveHandler);

    const render = () => {
      if (circleRef.current) {
        lastMousePos.x = MathUtils.lerp(
          lastMousePos.x,
          mousepos.x - circleRef.current.getBoundingClientRect().width / 2,
          0.2
        );
        lastMousePos.y = MathUtils.lerp(
          lastMousePos.y,
          mousepos.y - circleRef.current.getBoundingClientRect().height / 2,
          0.2
        );
        lastScale = MathUtils.lerp(lastScale, scale, 0.15);
        circleRef.current.style.transform = `translateX(${lastMousePos.x}px) translateY(${lastMousePos.y}px) scale(${lastScale})`;
        requestAnimationFrame(render);
      }
    };

    render();

    return () => {
      window.removeEventListener('resize', calcWinsize);
      window.removeEventListener('mousemove', mouseMoveHandler);
    };
  }, []);

  const enter = () => {
    scale = 1.9;
  };

  const leave = () => {
    scale = 1;
  };

  const showArrows = () => {
    TweenMax.to([arrowLeftRef.current, arrowRightRef.current], 1, {
      ease: Expo.easeOut,
      startAt: { x: (i) => (i ? 10 : -10) },
      opacity: 1,
      x: 0,
    });
  };

  const hideArrows = () => {
    TweenMax.to([arrowLeftRef.current, arrowRightRef.current], 1, {
      ease: Expo.easeOut,
      x: (i) => (i ? 10 : -10),
      opacity: 0,
    });
  };

  useEffect(() => {
    const links = document.querySelectorAll('.js-link');
    links.forEach((link) => {
      link.addEventListener('mouseenter', enter);
      link.addEventListener('mouseleave', leave);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener('mouseenter', enter);
        link.removeEventListener('mouseleave', leave);
      });
    };
  }, []);

  return (
    <div className="js-cursor" ref={cursorRef}>
      <div className="c-cursor__inner c-cursor__inner--circle js-cursor-inner" ref={circleRef}>
        <div className="c-cursor__side c-cursor__side--left js-cursor-right" ref={arrowLeftRef}></div>
        <div className="c-cursor__side c-cursor__side--right js-cursor-left" ref={arrowRightRef}></div>
      </div>
    </div>
  );
};

export default CustomCursor;
